import React, { useState, useEffect, useContext } from "react";
import qs from 'query-string'

import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import toastUtils from "../../utils/toastUtils";
import { Formik, Form, Field } from "formik";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import usePlans from '../../hooks/usePlans';
import { i18n } from "../../translate/i18n";
import { FormControl } from "@material-ui/core";
import { InputLabel, MenuItem, Select } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SUPPORTED_COUNTRIES, getCountryByCode } from "../../utils/countryList";
import IconButton from "@material-ui/core/IconButton";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Helmet } from "react-helmet";

import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import useSettings from "../../hooks/useSettings";
import ColorModeContext from "../../layout/themeContext";
import clsx from "clsx";
import { getBackendUrl } from "../../config";
import { sanitizeUrl } from "../../utils/sanitize";

const useStyles = makeStyles((theme) => ({
    // Mobile-first: Root da página
    root: {
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px 0",
        margin: "0",
        boxSizing: "border-box",
        overflow: "auto",
        backgroundColor: theme.palette.type === "light" ? "#f5f5f5" : "#121212",
        background: theme.palette.type === "light"
            ? "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)"
            : "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)",
        position: "relative",
        transition: "all 0.3s ease",

        // Padrão de pontos no fundo
        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: theme.palette.type === "light"
                ? `radial-gradient(circle at 25% 25%, rgba(255,255,255,0.05) 1px, transparent 1px),
                   radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 1px, transparent 1px)`
                : `radial-gradient(circle at 25% 25%, rgba(255,255,255,0.02) 1px, transparent 1px),
                   radial-gradient(circle at 75% 75%, rgba(255,255,255,0.02) 1px, transparent 1px)`,
            backgroundSize: "50px 50px",
            animation: "$float 20s ease-in-out infinite",
        },
    },

    "@keyframes float": {
        "0%, 100%": { transform: "translateY(0px) rotate(0deg)" },
        "50%": { transform: "translateY(-10px) rotate(180deg)" },
    },

    // Container - responsivo
    containerSignup: {
        padding: "16px",
        maxWidth: "960px", // Mais largo para acomodar 2 colunas no desktop
        width: "100%",
        position: "relative",
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        [theme.breakpoints.down("md")]: {
            maxWidth: "600px", // Tablet
        },
        [theme.breakpoints.down("sm")]: {
            maxWidth: "500px", // Mobile
        },
    },

    // Card do formulário
    paper: {
        backgroundColor: theme.palette.type === "light"
            ? "rgba(255, 255, 255, 0.95)"
            : "rgba(18, 18, 18, 0.95)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        boxShadow: theme.palette.type === "light"
            ? `0 20px 40px rgba(0, 0, 0, 0.1),
               0 1px 0 rgba(255, 255, 255, 0.2) inset,
               0 0 0 1px rgba(255, 255, 255, 0.1)`
            : `0 20px 40px rgba(0, 0, 0, 0.3),
               0 1px 0 rgba(255, 255, 255, 0.05) inset,
               0 0 0 1px rgba(255, 255, 255, 0.05)`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "40px 30px",
        borderRadius: "20px",
        width: "100%",
        margin: "0 auto",
        border: theme.palette.type === "light"
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(255, 255, 255, 0.1)",
        animation: "$slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
        transition: "all 0.3s ease",

        [theme.breakpoints.down("sm")]: {
            padding: "30px 20px",
            borderRadius: "16px",
        },
    },

    "@keyframes slideInUp": {
        from: {
            opacity: 0,
            transform: "translateY(30px)",
        },
        to: {
            opacity: 1,
            transform: "translateY(0)",
        },
    },

    // Logo
    logoImg: {
        width: "100%",
        maxWidth: "240px",
        height: "auto",
        maxHeight: "70px",
        margin: "0 auto 20px auto",
        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
        content: "url(" + (theme.mode === "light"
            ? theme.calculatedLogoLight()
            : theme.calculatedLogoDark()) + ")",

        [theme.breakpoints.down("sm")]: {
            maxWidth: "200px",
            maxHeight: "60px",
        },
    },

    // Título
    title: {
        color: theme.palette.type === "light" ? "#1e293b !important" : "#f1f5f9 !important",
        fontWeight: 700,
        fontSize: "1.75rem",
        marginBottom: theme.spacing(3),
        textAlign: "center",

        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
            marginBottom: theme.spacing(2),
        },
    },

    // Formulário
    form: {
        width: "100%",
        marginTop: theme.spacing(2),
    },

    // Campos de input - consistente com Login
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: theme.palette.type === "light"
                ? "rgba(255, 255, 255, 0.8)"
                : "rgba(30, 30, 30, 0.8)",
            backdropFilter: "blur(10px)",
            transition: "all 0.3s ease",
            "&:hover": {
                backgroundColor: theme.palette.type === "light"
                    ? "rgba(255, 255, 255, 0.9)"
                    : "rgba(30, 30, 30, 0.9)",
            },
            "&.Mui-focused": {
                backgroundColor: theme.palette.type === "light"
                    ? "rgba(255, 255, 255, 1)"
                    : "rgba(30, 30, 30, 1)",
                boxShadow: theme.palette.type === "light"
                    ? "0 0 0 3px rgba(59, 130, 246, 0.1)"
                    : "0 0 0 3px rgba(100, 150, 255, 0.2)",
            },
            "& fieldset": {
                borderColor: theme.palette.type === "light"
                    ? "rgba(59, 130, 246, 0.2)"
                    : "rgba(100, 150, 255, 0.3)",
            },
            "&:hover fieldset": {
                borderColor: theme.palette.type === "light"
                    ? "rgba(59, 130, 246, 0.4)"
                    : "rgba(100, 150, 255, 0.5)",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.type === "light" ? "#3b82f6" : "#6496ff",
                borderWidth: "2px",
            },
        },
        "& .MuiInputLabel-root": {
            color: theme.palette.type === "light" ? "#6b7280" : "#94a3b8",
            fontWeight: 500,
            "&.Mui-focused": {
                color: theme.palette.type === "light" ? "#3b82f6" : "#6496ff",
            },
        },
    },

    // Botão submit
    submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderRadius: "12px",
        padding: "14px 0",
        fontSize: "16px",
        fontWeight: 600,
        textTransform: "none",
        boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
        border: "none",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            transform: "translateY(-2px)",
            boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
        },
        "&:active": {
            transform: "translateY(0)",
        },
        "&:disabled": {
            opacity: 0.6,
        },

        [theme.breakpoints.down("sm")]: {
            padding: "12px 0",
            fontSize: "15px",
        },
    },

    // Botão de toggle tema
    iconButton: {
        position: "absolute",
        top: 15,
        right: 15,
        background: theme.palette.type === "light"
            ? "rgba(255, 255, 255, 0.1)"
            : "rgba(255, 255, 255, 0.05)",
        backdropFilter: "blur(10px)",
        border: theme.palette.type === "light"
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(255, 255, 255, 0.1)",
        color: theme.palette.type === "light" ? "#374151" : "#e2e8f0",
        transition: "all 0.3s ease",
        zIndex: 10,
        "&:hover": {
            background: theme.palette.type === "light"
                ? "rgba(255, 255, 255, 0.2)"
                : "rgba(255, 255, 255, 0.1)",
            transform: "scale(1.05)",
        },
    },

    // Link de login
    loginLink: {
        color: theme.palette.type === "light" ? "#3b82f6" : "#6496ff",
        textDecoration: "none",
        fontWeight: 600,
        transition: "all 0.3s ease",
        "&:hover": {
            color: theme.palette.type === "light" ? "#2563eb" : "#5078ff",
            textDecoration: "underline",
        },
    },
}));

const UserSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
    companyName: Yup.string()
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
    country: Yup.string().required("Required"),
    document: Yup.string()
        .test('document-format', 'Documento inválido', function(value) {
            const { country } = this.parent;
            const countryData = getCountryByCode(country || 'BR');

            // Se documento não é obrigatório para o país, pode estar vazio
            if (!countryData.documentRequired && (!value || value.trim() === '')) {
                return true;
            }

            // Se é obrigatório ou foi preenchido, validar
            if (!value) return false;
            const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
            return cleanValue.length >= countryData.minLength && cleanValue.length <= countryData.maxLength;
        })
        .when('country', {
            is: 'BR',
            then: Yup.string().required("CPF ou CNPJ é obrigatório"),
            otherwise: Yup.string()
        }),
    password: Yup.string().min(5, "Too Short!").max(50, "Too Long!"),
    email: Yup.string().email("Invalid email").required("Required"),
    phone: Yup.string().required("Required"),
});

const SignUp = () => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const { colorMode } = useContext(ColorModeContext);
    const { appLogoFavicon, appName } = colorMode;
    const mode = theme.palette.type;
    const { getPlanList } = usePlans()
    const [plans, setPlans] = useState([])
    const [loading, setLoading] = useState(false);
    const [validatingCnpj, setValidatingCnpj] = useState(false);
    const [lastValidatedDocument, setLastValidatedDocument] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const { getPublicSetting } = useSettings();
    const [backgroundLight, setBackgroundLight] = useState("");
    const [backgroundDark, setBackgroundDark] = useState("");
    const [backgroundColorLight, setBackgroundColorLight] = useState("");
    const [backgroundColorDark, setBackgroundColorDark] = useState("");

    let companyId = null
    const params = qs.parse(window.location.search)
    if (params.companyId !== undefined) {
        companyId = params.companyId
    }

    const initialState = { name: "", email: "", password: "", phone: "", companyId, companyName: "", document: "", planId: "", country: "BR" };

    const [user] = useState(initialState);
    const [selectedCountry, setSelectedCountry] = useState("BR");

    useEffect(() => {
        getPublicSetting("userCreation")
            .then((data) => {
                if (data === "disabled") {
                    toastUtils.error(i18n.t("signup.toasts.disabled"), "Cadastro Desabilitado");
                    history.push("/login");
                }
            })
            .catch((error) => {
                console.log("Error reading setting", error);
            });

        getPublicSetting("appLogoBackgroundLight", companyId)
            .then((bgLight) => {
                if (bgLight) {
                    setBackgroundLight(getBackendUrl() + "/public/" + bgLight);
                } else {
                    setBackgroundLight("");
                }
            })
            .catch(() => {
                setBackgroundLight("");
            });

        getPublicSetting("appLogoBackgroundDark", companyId)
            .then((bgDark) => {
                if (bgDark) {
                    setBackgroundDark(getBackendUrl() + "/public/" + bgDark);
                } else {
                    setBackgroundDark("");
                }
            })
            .catch(() => {
                setBackgroundDark("");
            });

        getPublicSetting("backgroundColorLight", companyId)
            .then((colorLight) => {
                setBackgroundColorLight(colorLight || "");
            })
            .catch(() => {
                setBackgroundColorLight("");
            });

        getPublicSetting("backgroundColorDark", companyId)
            .then((colorDark) => {
                setBackgroundColorDark(colorDark || "");
            })
            .catch(() => {
                setBackgroundColorDark("");
            });
    }, []);

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            const planList = await getPlanList({ listPublic: "false" });

            setPlans(planList);
            setLoading(false);
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Função para validar CPF
    const validateCpf = (cpf) => {
        // Remove caracteres não numéricos
        const cleanCpf = cpf.replace(/\D/g, '');
        
        // Verifica se tem 11 dígitos
        if (cleanCpf.length !== 11) return false;
        
        // Verifica se todos os dígitos são iguais
        if (/^(\d)\1{10}$/.test(cleanCpf)) return false;
        
        // Validação do primeiro dígito verificador
        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
        }
        let remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanCpf.charAt(9))) return false;
        
        // Validação do segundo dígito verificador
        sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
        }
        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanCpf.charAt(10))) return false;
        
        return true;
    };

    // Função para formatar CPF
    const formatCpf = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 11);
        
        if (limitedNumbers.length <= 3) return limitedNumbers;
        if (limitedNumbers.length <= 6) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3)}`;
        if (limitedNumbers.length <= 9) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6)}`;
        return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6, 9)}-${limitedNumbers.slice(9)}`;
    };

    // Função para formatar CNPJ
    const formatCnpj = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 14);
        
        if (limitedNumbers.length <= 2) return limitedNumbers;
        if (limitedNumbers.length <= 5) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2)}`;
        if (limitedNumbers.length <= 8) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5)}`;
        if (limitedNumbers.length <= 12) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8)}`;
        return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8, 12)}-${limitedNumbers.slice(12)}`;
    };

    // Função para detectar se é CPF ou CNPJ
    const detectDocumentType = (value) => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length <= 11) return 'cpf';
        return 'cnpj';
    };

    // Função para formatar documento (CPF ou CNPJ)
    const formatDocument = (value) => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length <= 11) {
            return formatCpf(value);
        } else {
            return formatCnpj(value);
        }
    };

    const validateDocument = async (document, country, setFieldValue) => {
        const cleanDocument = document.replace(/[^a-zA-Z0-9]/g, '');

        // Evitar validação duplicada
        if (lastValidatedDocument === cleanDocument) {
            return true;
        }

        const countryData = getCountryByCode(country);

        // Se documento não é obrigatório e está vazio, permitir
        if (!countryData.documentRequired && (!document || document.trim() === '')) {
            return true;
        }

        setValidatingCnpj(true);
        try {
            const response = await openApi.post("/auth/validate-cnpj", {
                document: document,
                country: country
            });
            const data = response.data;
            setValidatingCnpj(false);

            if (data.valid && data.data) {
                // Se for CNPJ brasileiro, preencher o nome da empresa
                if (country === 'BR' && data.data.tipo === 'cnpj' && data.data.nome) {
                    setFieldValue('companyName', data.data.nome);
                    toastUtils.success("CNPJ válido! Nome da empresa preenchido automaticamente.", "Empresa Encontrada");
                } else if (country === 'BR' && data.data.tipo === 'cpf') {
                    toastUtils.success("CPF válido!", "Documento Válido");
                } else {
                    toastUtils.success("Documento válido!", "Documento Válido");
                }
                setLastValidatedDocument(cleanDocument);
                return true;
            } else {
                setLastValidatedDocument(cleanDocument);
                toastUtils.error("Documento inválido", "Documento Inválido");
                return false;
            }
        } catch (error) {
            setValidatingCnpj(false);
            console.error("Erro ao validar documento:", error);
            toastUtils.error("Erro ao validar documento. Tente novamente.", "Erro Validação");
            setLastValidatedDocument(cleanDocument);
            return false;
        }
    };

    const handleSignUp = async values => {
        try {
            // Sanitizar dados antes do envio
            const sanitizedValues = {
                ...values,
                document: values.document?.replace(/[^a-zA-Z0-9]/g, '') || '',
                phone: values.phone?.replace(/[^\d+]/g, '') || '', // Apenas + e números
            };

            await openApi.post("/auth/signup", sanitizedValues);
            toastUtils.success(i18n.t("signup.toasts.success"), "Conta Criada");
            history.push("/login");
        } catch (err) {
            toastError(err);
        }
    };

    // Determinar background baseado no tema
    let finalBackground;
    if (mode === "light") {
        if (backgroundLight) {
            finalBackground = `url(${backgroundLight})`;
        } else if (backgroundColorLight) {
            finalBackground = backgroundColorLight;
        } else {
            finalBackground = "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)";
        }
    } else {
        if (backgroundDark) {
            finalBackground = `url(${backgroundDark})`;
        } else if (backgroundColorDark) {
            finalBackground = backgroundColorDark;
        } else {
            finalBackground = "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)";
        }
    }

    finalBackground = String(finalBackground || "#f5f5f5");

    return (
        <>
            <Helmet>
                <title>{appName ? `${i18n.t("signup.title")} - ${appName}` : i18n.t("signup.title")}</title>
                <link rel="icon" href={appLogoFavicon || "/favicon.ico"} />
            </Helmet>

            <div
                className={clsx(classes.root, "signup-page")}
                style={{
                    width: '100vw',
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px 0',
                    margin: '0',
                    boxSizing: 'border-box',
                    overflow: 'auto',
                    backgroundColor:
                        typeof finalBackground === "string" &&
                        finalBackground.includes("url(")
                            ? "transparent"
                            : finalBackground,
                    backgroundImage:
                        typeof finalBackground === "string" &&
                        finalBackground.includes("url(")
                            ? finalBackground
                            : "none",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <Container
                    component="main"
                    className={classes.containerSignup}
                >
                    <CssBaseline />
                    <div className={classes.paper}>
                        {/* Botão de toggle tema */}
                        <IconButton
                            className={classes.iconButton}
                            onClick={colorMode.toggleColorMode}
                        >
                            {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
                        </IconButton>

                        {/* Logo */}
                        <div>
                            <img className={classes.logoImg} alt="logo" />
                        </div>

                        {/* Título */}
                        <Typography component="h1" variant="h5" className={classes.title}>
                            {i18n.t("signup.title")}
                        </Typography>

                        <Formik
                            initialValues={user}
                            enableReinitialize={true}
                            validationSchema={UserSchema}
                            onSubmit={(values, actions) => {
                                setTimeout(() => {
                                    handleSignUp(values);
                                    actions.setSubmitting(false);
                                }, 400);
                            }}
                        >
                            {({ touched, errors, isSubmitting, setFieldValue }) => (
                                <Form className={classes.form}>
                                    <Grid container spacing={2}>
                                        {/* País - Desktop: metade da largura, Mobile: largura total */}
                                        <Grid item xs={12} md={6}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="country-label">
                                                    {i18n.t("signup.form.country")}
                                                </InputLabel>
                                                <Field
                                                    as={Select}
                                                    labelId="country-label"
                                                    id="country"
                                                    name="country"
                                                    label={i18n.t("signup.form.country")}
                                                    onChange={(e) => {
                                                        setFieldValue('country', e.target.value);
                                                        setSelectedCountry(e.target.value);
                                                        setFieldValue('document', '');
                                                        setLastValidatedDocument('');
                                                    }}
                                                >
                                                    {SUPPORTED_COUNTRIES.map((country) => (
                                                        <MenuItem key={country.code} value={country.code}>
                                                            <span style={{ marginRight: 8 }}>{country.flag}</span>
                                                            {i18n.language === 'en' ? country.nameEn : i18n.language === 'es' ? country.nameEs : country.name}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                            </FormControl>
                                        </Grid>

                                        {/* Documento - Desktop: metade da largura, Mobile: largura total */}
                                        <Grid item xs={12} md={6}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="document"
                                                label={(() => {
                                                    const countryData = getCountryByCode(selectedCountry);
                                                    const label = i18n.language === 'en' ? countryData.documentLabelEn :
                                                                  i18n.language === 'es' ? countryData.documentLabelEs :
                                                                  countryData.documentLabel;
                                                    return label + (countryData.documentRequired ? '' : ` (${i18n.t("signup.form.optional")})`);
                                                })()}
                                                name="document"
                                                error={touched.document && Boolean(errors.document)}
                                                helperText={touched.document && errors.document || getCountryByCode(selectedCountry).documentPlaceholder}
                                                autoComplete="document"
                                               
                                                inputProps={{
                                                    maxLength: 30,
                                                    style: { textTransform: 'none' }
                                                }}
                                                InputProps={{
                                                    endAdornment: validatingCnpj && (
                                                        <CircularProgress size={20} />
                                                    ),
                                                }}
                                                autoFocus
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    const countryData = getCountryByCode(selectedCountry);

                                                    const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
                                                    if (lastValidatedDocument && lastValidatedDocument !== cleanValue) {
                                                        setLastValidatedDocument("");
                                                    }

                                                    if (selectedCountry === 'BR') {
                                                        const formattedValue = formatDocument(value);
                                                        setFieldValue('document', formattedValue);

                                                        const numbers = value.replace(/\D/g, '');
                                                        if (numbers.length === 11 || numbers.length === 14) {
                                                            validateDocument(formattedValue, selectedCountry, setFieldValue);
                                                        }
                                                    } else {
                                                        setFieldValue('document', value);

                                                        if (cleanValue.length >= countryData.minLength) {
                                                            validateDocument(value, selectedCountry, setFieldValue);
                                                        }
                                                    }
                                                }}
                                            />
                                        </Grid>

                                        {/* Nome da Empresa - Largura total */}
                                        <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="companyName"
                                                label={i18n.t("signup.form.company")}
                                                error={touched.companyName && Boolean(errors.companyName)}
                                                helperText={touched.companyName && errors.companyName}
                                                name="companyName"
                                                autoComplete="companyName"
                                               
                                            />
                                        </Grid>

                                        {/* Nome - Desktop: metade da largura, Mobile: largura total */}
                                        <Grid item xs={12} md={6}>
                                            <Field
                                                as={TextField}
                                                autoComplete="name"
                                                name="name"
                                                error={touched.name && Boolean(errors.name)}
                                                helperText={touched.name && errors.name}
                                                variant="outlined"
                                                fullWidth
                                                id="name"
                                                label={i18n.t("signup.form.name")}
                                               
                                            />
                                        </Grid>

                                        {/* Email - Desktop: metade da largura, Mobile: largura total */}
                                        <Grid item xs={12} md={6}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="email"
                                                label={i18n.t("signup.form.email")}
                                                name="email"
                                                error={touched.email && Boolean(errors.email)}
                                                helperText={touched.email && errors.email}
                                                autoComplete="email"
                                               
                                                inputProps={{ style: { textTransform: 'lowercase' } }}
                                            />
                                        </Grid>

                                        {/* Senha - Desktop: metade da largura, Mobile: largura total */}
                                        <Grid item xs={12} md={6}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                name="password"
                                                error={touched.password && Boolean(errors.password)}
                                                helperText={touched.password && errors.password}
                                                label={i18n.t("signup.form.password")}
                                                type={showPassword ? "text" : "password"}
                                                id="password"
                                                autoComplete="current-password"
                                               
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                edge="end"
                                                                style={{ color: "#6b7280" }}
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                        {/* Telefone - Desktop: metade da largura, Mobile: largura total */}
                                        <Grid item xs={12} md={6}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="phone"
                                                label={i18n.t("signup.form.phone")}
                                                name="phone"
                                                autoComplete="phone"
                                               
                                            />
                                        </Grid>

                                        {/* Plano - Largura total */}
                                        <Grid item xs={12}>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel htmlFor="plan-selection">Plano</InputLabel>
                                                <Field
                                                    as={Select}
                                                    variant="outlined"
                                                    fullWidth
                                                    id="plan-selection"
                                                    label="Plano"
                                                    name="planId"
                                                    required
                                                >
                                                    {plans.map((plan, key) => (
                                                        <MenuItem key={key} value={plan.id}>
                                                            {plan.name} - Atendentes: {plan.users} - WhatsApp: {plan.connections} - Filas: {plan.queues} - $ {plan.amount}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    {/* Botão de submit */}
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        disabled={validatingCnpj}
                                    >
                                        {i18n.t("signup.buttons.submit")}
                                    </Button>

                                    {/* Link para login */}
                                    <Grid container justifyContent="center">
                                        <Grid item>
                                            <Link
                                                href="#"
                                                variant="body2"
                                                component={RouterLink}
                                                to="/login"
                                                className={classes.loginLink}
                                            >
                                                {i18n.t("signup.buttons.login")}
                                            </Link>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default SignUp;